import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import s from './SectionTitle.module.css';

const SectionTitle = ({ title, onTitleChange }) => {
    const { t } = useTranslation();
    const { id } = useParams();

    useEffect(() => {
        if (id === undefined) onTitleChange(t('section title'));
    }, [id, onTitleChange, t]);

    return (
        <header className={s.header}>
            <p>{id ? t('writing.article') : t('writing.eyebrow')}</p>
            <h1>{title}</h1>
            {!id && <span>{t('writing.description')}</span>}
        </header>
    );
};

export default SectionTitle;
